
const randomHex = (length: number) => {
    const bytes = new Uint8Array(Math.ceil(length / 2));
    crypto.getRandomValues(bytes);
    return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('').slice(0, length);
};

export const newSurveyObjectId = (): string => {
    const timestamp = Math.floor(Date.now() / 1000).toString(16).padStart(8, '0');
    return `${timestamp}${randomHex(16)}`;
};

const OBJECT_ID_PATTERN = /^[0-9a-f]{24}$/i;

/** Whether a value is shaped like a stored id, so a pasted id can be looked up as one instead of searched as a name. */
export const isSurveyObjectId = (value: string): boolean => OBJECT_ID_PATTERN.test(value.trim());
